import { render, staticRenderFns } from "./CoPage.vue?vue&type=template&id=54d7c3d8&scoped=true&"
import script from "./CoPage.vue?vue&type=script&lang=ts&"
export * from "./CoPage.vue?vue&type=script&lang=ts&"
import style0 from "./CoPage.vue?vue&type=style&index=0&id=54d7c3d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d7c3d8",
  null
  
)

export default component.exports